import { environment } from '@environment/environment';

export const LANDING_PAGES: LandingPages = {
	DASHBOARD: {
		label: 'Dashboard',
		value: 'dashboard',
	},
	CAPACITY: {
		label: 'Capacity',
		value: 'capacity',
	},
	CARRIERS: {
		label: 'Network',
		value: 'carriers',
	},
	PROJECTS: {
		label: 'Projects',
		value: 'projects',
	},
};

export const getCarrierLandingPages = (isPaidPlan: boolean): LandingPages => {
	return {
		AVAILABLE_LOADS: {
			label: 'Available Loads',
			value: 'carriers/availableLoads',
		},
		BOOKED_LOADS: {
			label: 'Booked Loads',
			value: 'carriers/bookedLoads',
		},
		...(isPaidPlan && {
			LANES: {
				label: 'Lanes',
				value: 'carriers/lanes',
			},
		}),
		...(environment.FEATURE_FLAGS.CARRIER_NAVBAR_MENU.NETWORK && {
			NETWORK: {
				label: 'Network',
				value: 'carriers/network',
			},
		}),
	};
};

// Keep for backward compatibility with session.effects.ts
export const CARRIER_LANDING_PAGES: LandingPages = getCarrierLandingPages(false);

interface LandingPages {
	[key: string]: {
		label: string;
		value: string;
	};
}
